import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { type ComponentProps } from "react";

import { cn } from "../../utils/cn.util";
import { MenuItem, menuItemContent, type MenuItemContentProps, type MenuItemProps } from "../menu-item";

export type DropdownMenuSubTriggerProps = Omit<ComponentProps<typeof DropdownMenuPrimitive.SubTrigger>, "children"> &
  Pick<MenuItemProps, "leading"> &
  MenuItemContentProps & {
    inset?: boolean;
    hideIcon?: boolean;
  };

export const SubTrigger = (props: DropdownMenuSubTriggerProps) => {
  const { leading, ref, className, inset, hideIcon = false, label, description, children, ...triggerProps } = props;

  return (
    <DropdownMenuPrimitive.SubTrigger ref={ref} {...triggerProps} asChild>
      <MenuItem
        leading={leading}
        {...menuItemContent(label, description, children)}
        // `hideIcon` only drops the chevron: Radix still marks the row as opening a submenu.
        hasSubmenu={!hideIcon}
        className={cn("data-[state=open]:bg-neutral-95", inset && "pl-8", className)}
      />
    </DropdownMenuPrimitive.SubTrigger>
  );
};

SubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
